import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { EmergesService } from 'src/app/shared/services/API/emerges-key/emerges.service';

@Component({
  selector: 'app-emerges-delete-modal',
  templateUrl: './emerges-delete-modal.component.html',
  styleUrls: ['./emerges-delete-modal.component.css']
})
export class EmergesDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialog: MatDialog, 
  public matDialogRef: MatDialogRef<EmergesDeleteModalComponent>,
  private emergesService: EmergesService,
  private alertService: AlertService,) { }
  
  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteEmerges: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.emergesService.deleteEmerges(this.data.idEmerges).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Emerges excluído com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteEmerges: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteEmerges: false}); 
  }

}